import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Enterprise = () => {
  return (
    <>
    <Navbar />
 <div style={{ backgroundColor: "#f4f9f7" }}>
      
      {/* HERO SECTION */}
      <div
        style={{
          background: "linear-gradient(135deg, #0f5132, #198754)",
          color: "white",
          padding: "100px 0",
        }}
      >
        <Container className="text-center">
          <h1 className="fw-bold mb-4">
            Enterprise Builds: Bespoke E&S Engineering
          </h1>
          <p className="lead" style={{ maxWidth: "750px", margin: "0 auto" }}>
            Your data. Your rules. Custom-engineered intelligence for the
            world’s most complex Environmental & Social challenges.
          </p>
        </Container>
      </div>

      <Container className="py-5">

        {/* Knowledge Section */}
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="fw-bold text-success mb-3">
              Intelligent Knowledge Management
            </h2>
            <p className="text-muted">
              Transform how your organization manages, accesses, and protects institutional expertise.
            </p>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          {[
            {
              title: "Private Knowledge Bases",
              text: "Centralize proprietary research, technical documentation, and SOPs into a secure AI-powered hub.",
            },
            {
              title: "AI-Powered Intelligence",
              text: "Use NLP to chat with your data and retrieve insights instantly with smart indexing.",
            },
            {
              title: "Flexible Deployment",
              text: "Cloud scalability or on-premise hosting for complete enterprise-level control.",
            },
          ].map((item, index) => (
            <Col md={4} key={index}>
              <Card
                className="h-100 border-0 shadow-sm rounded-4"
                style={{
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-8px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0px)")
                }
              >
                <Card.Body>
                  <Card.Title className="fw-bold text-success mb-3">
                    {item.title}
                  </Card.Title>
                  <Card.Text className="text-muted">
                    {item.text}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Analytics Section */}
        <div
          className="rounded-4 p-5 mb-5"
          style={{ backgroundColor: "#e9f7ef" }}
        >
          <Row className="mb-4">
            <Col className="text-center">
              <h2 className="fw-bold text-success">
                Advanced Analytics: From Data to Foresight
              </h2>
              <p className="text-muted">
                Move beyond static reporting into predictive intelligence.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6}>
              <Card className="border-0 shadow-sm rounded-4 h-100">
                <Card.Body>
                  <Card.Title className="fw-bold text-success">
                    ML Sentiment Analysis & Risk Mapping
                  </Card.Title>
                  <ul className="text-muted mt-3">
                    <li>Real-time stakeholder risk detection</li>
                    <li>Geographic Sentiment Heatmaps</li>
                    <li>Audit-ready traceable engagement logs</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="border-0 shadow-sm rounded-4 h-100">
                <Card.Body>
                  <Card.Title className="fw-bold text-success">
                    Strategic Scenario Modelling (SEA)
                  </Card.Title>
                  <ul className="text-muted mt-3">
                    <li>30-Year Environmental & Social forecasting</li>
                    <li>Data-driven resilient strategy planning</li>
                    <li>Future-proof compliance frameworks</li>
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Free Tool Section */}
        <Row className="mb-5">
          <Col className="text-center">
            <h2 className="fw-bold text-success mb-3">
              Free Tool: AI File Management
            </h2>
            <p className="text-muted mb-4">
              Our AI Renaming Script is 100% free and fully private.
            </p>
            <div className="d-inline-block text-start">
              <ul className="text-muted">
                <li>Context-aware structured file naming</li>
                <li>Runs entirely in your environment</li>
                <li>Zero data leaves your system</li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Why Choose */}
        <Row className="text-center mb-5">
          <Col>
            <h2 className="fw-bold text-success mb-4">
              Why Choose Bespoke Engineering?
            </h2>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          {[
            "Preserve institutional expertise as teams evolve.",
            "Enable seamless global collaboration.",
            "Zero hallucinations. Verified data. Security-first architecture.",
          ].map((text, i) => (
            <Col md={4} key={i}>
              <Card className="border-0 shadow-sm rounded-4 text-center p-4">
                <Card.Body>
                  <Card.Text className="text-muted fw-semibold">
                    {text}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* CTA */}
        <Row className="text-center mb-5">
          <Col>
            <Button
              variant="success"
              size="lg"
              href="mailto:info@essolutions.ai?subject=Enterprise Build Inquiry"
              className="px-5 py-3 rounded-pill shadow"
            >
              Contact Our Engineering Team
            </Button>
          </Col>
        </Row>

        {/* Quick Support */}
        <Row className="text-center pt-4 border-top">
          <Col>
            <p className="text-muted">
              Questions? Reach out to your dedicated contact person or email{" "}
              <a href="mailto:info@essolutions.ai">info@essolutions.ai</a>.
              <br />
              For troubleshooting and guides, visit our <a href="/faq">FAQ</a>.
            </p>
          </Col>
        </Row>

      </Container>
    </div>
    <Footer />
    </>
  );
};

export default Enterprise;